import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_040.jpg';
page.games = [
  // {
  //   id: 'page010_game1',
  //   tooltip: '',
  //   icon: 'ikona_cw1',
  //   pos: {
  //     x: RIGHT,
  //     y: 0,
  //   },
  // },
  {
    id: 'page020_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page020_game2',
    tooltip: '',
    icon: 'ikona_cw2',
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page020_game3',
    tooltip: '',
    icon: 'ikona_cw3',
    pos: {
      x: LEFT,
      y: 400,
    },
  },
  {
    id: 'page040_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: LEFT,
      y: 598,
    },
    item: {
      id: 'page040_game10',
    },
    rectangle: {
      id: 'page040_rect0',
    },
  },
  // {
  //   id: 'page019_game4',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 600,
  //   },
  // },
  // {
  //   id: 'page010_game5',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 800,
  //   },
  // },
];
page.rectangle = [
  {
    id: 'page040_rect0',

    tooltip: '',

    linked: ['page040_game10'],
    x: 120,
    y: 598,
    width: 458,
    height: 772,
  },
];
page.images = [
  {
    imageId: 'page040_zoom0',
    rectangle: {
      x: 136 + 160,
      y: 1696,
      width: 1638 - 160,
      height: 762,
    },
    imageSrc: 'images/page040/040 2.jpg',
  },
  {
    imageId: 'page040_zoom1',
    rectangle: {
      x: 610,
      y: 614,
      width: 1162,
      height: 742,
    },
    imageSrc: 'images/page040/040 1.jpg',
  },
];
export default page;
